export default (label, filter) => {
  const regex = new RegExp(`(${filter})`, 'gi');
  return label.replace(regex, '<span class="tp--b">$1</span>');
};
